import { IntlShape } from 'react-intl';

export const getFormattedDate = (date: Date | null, intl: IntlShape): string => {
    if (!date) {
        return '';
    }
    const day = date.getDate();
    const month = date.getMonth() + 1;

    return intl.formatMessage({ id: 'lessonPassport.dates.date' }, { day, month });
};

export const getSpecCourseDatesStr = (
    dateAssignment: Date | string | null,
    dateDeadline: Date | string | null,
    intl: IntlShape
) => {
    const assignDate = getFormattedDate(dateAssignment ? new Date(dateAssignment) : null, intl);
    const deadlineDate = getFormattedDate(dateDeadline ? new Date(dateDeadline) : null, intl);

    if (!dateAssignment) {
        return intl.formatMessage({ id: 'lessonPassport.dates.period.empty' });
    }

    if (!dateDeadline) {
        return intl.formatMessage(
            { id: 'lessonPassport.dates.period.onlyAssign' },
            {
                begin: assignDate,
            }
        );
    }

    return intl.formatMessage(
        { id: 'lessonPassport.dates.period' },
        {
            begin: assignDate,
            end: deadlineDate,
        }
    );
};
